import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightTarget as DeprecatedSpotlightTarget } from '@atlaskit/onboarding';
import { fg } from '@atlaskit/platform-feature-flags';

import { target as targetTranslation } from './translations/target.tsx';

export interface SpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */
const SpotlightTarget: {
	({ children, name }: SpotlightTargetProps): React.JSX.Element;
	displayName: string;
} = ({ children, name }: SpotlightTargetProps): React.JSX.Element => {
	const id = targetTranslation(name);

	if (fg('post-office_enable_ads_spotlight_migration')) {
		return <div id={id}>{children}</div>;
	}

	return <DeprecatedSpotlightTarget name={name}>{children}</DeprecatedSpotlightTarget>;
};

SpotlightTarget.displayName = 'SpotlightTarget';

export { SpotlightTarget };
